import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const SPEND_LIMIT_PERIODS_KEY = 'SPEND_LIMIT_PERIODS';

const useGetHealthPlanYearsQuery = (id?: string) => {
  const { isLoading, isError, isSuccess, data } = useQuery(
    [SPEND_LIMIT_PERIODS_KEY, id],
    () => {
      return api.get(API_URL.PLAN_YEARS_HEALTH_PLANS, {
        params: { employee_id: id },
      });
    },
    {
      enabled: !!id,
    }
  );

  return {
    data: data?.data,
    isLoading,
    isError,
    isSuccess,
  };
};

export default useGetHealthPlanYearsQuery;
